import React from 'react';
import Svg from 'react-inlinesvg';
import IconClose from '../../../../assets/icons/CloseIcon.svg';
import { StyledMobileHeader, HeaderTitle, FlexDiv } from './styled';

const MobileHeader = ({ title, icon, actionText, onClose }) => {
  return (
    <StyledMobileHeader>
      <FlexDiv>
        <Svg src={icon} className="demo-icon" />
        <HeaderTitle>{`${title} ${actionText}`}</HeaderTitle>
      </FlexDiv>
      <Svg src={IconClose} className="icon-close" onClick={onClose} />
    </StyledMobileHeader>
  );
};

export default MobileHeader;
